// extracted by mini-css-extract-plugin
module.exports = {"totalAmount":"OnlinePaymentCard_totalAmount__3I6Mf"};